import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { VinculacionRolActividadInput } from '../entity-roles/roles.model';

@Component({
  selector: 'rpe-consentimiento-informado',
  templateUrl: './consentimiento-informado.component.html',
  styleUrls: ['./consentimiento-informado.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsentimientoInformadoComponent implements OnInit {
  @Input()
  set formInput(vinculacionRolActividadInput: VinculacionRolActividadInput) {
    if (vinculacionRolActividadInput != null) {
      // console.log('rolDetailFormInput vinculo', consentimientoInformadoInput);
      this._formInput = vinculacionRolActividadInput;
    }
  }

  fecha: string;

  get formInput(): VinculacionRolActividadInput {
    return this._formInput;
  }

  _formInput: VinculacionRolActividadInput;

  constructor() {}

  ngOnInit() {}
}
